```
<template>
  <div id="app">
    <Navbar />
    <router-view />
    <LoginModal v-model="authStore.showLoginModal" @login-success="handleLoginSuccess" />
  </div>
</template>

<script setup>
import Navbar from './components/Navbar.vue'
import LoginModal from './components/LoginModal.vue';
import { authStore } from './utils/authStore';

authStore.checkLoginStatus();

const handleLoginSuccess = (data) => {
  authStore.login(data, data.token);
};
</script>
```<style>
body {
            font-family: 'Inter', sans-serif;
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
            color: #1e293b;
        }
        
        .glass-card {
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            box-shadow: 0 8px 32px rgba(31, 38, 135, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
        }
        
        .btn-primary {
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            color: white;
            transition: all 0.3s ease;
        }
        
        .btn-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 15px -3px rgba(99, 102, 241, 0.3);
        }
        
        .btn-secondary {
            background: linear-gradient(135deg, #f472b6 0%, #ec4899 100%);
            color: white;
            transition: all 0.3s ease;
        }
        
        .btn-secondary:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 15px -3px rgba(244, 114, 182, 0.3);
        }
        
        .text-gradient {
            background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
        }
        
        .modal {
            transition: all 0.3s ease;
            opacity: 0;
            visibility: hidden;
        }
        
        .modal.active {
            opacity: 1;
            visibility: visible;
        }
        
        .tab-content {
            display: none;
        }
        
        .tab-content.active {
            display: block;
            animation: fadeIn 0.5s ease;
        }
        
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }
</style>